export default {
	value: 0,
	min: 0,
	max: 100,
};
